import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import api from '../../Axios/middleware';
import {
  failureGetDisplayDevice,
  successGetDisplayDevice,
} from './DisplayDeviceSlicer';
import {
  failureAddDisplayDevice,
  successAddDisplayDevice,
} from './AddDisplayDeviceSlicer';
import {
  failureUpdateDisplayDevice,
  successUpdateDisplayDevice,
} from './UpdateDisplayDeviceSlicer';
import {
  failureDeleteDisplayDevice,
  successDeleteDisplayDevice,
} from './DeleteDisplayDeviceSlice';

// GET list by location_id
const DisplayDeviceApi = (action: PayloadAction<string>) =>
  api.get(`/display-devices/${action.payload}`);

export function* DisplayDeviceCall(action: PayloadAction<string>) {
  try {
    const response: AxiosResponse = yield call(DisplayDeviceApi, action);
    yield put(successGetDisplayDevice(response.data));
  } catch (error) {
    yield put(failureGetDisplayDevice(error));
  }
}

// POST create
const AddDisplayDeviceApi = (action: PayloadAction<any>) =>
  api.post('/display-devices/create', action.payload);

export function* AddDisplayDeviceCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(AddDisplayDeviceApi, action);
    yield put(successAddDisplayDevice(response.data));
  } catch (error) {
    yield put(failureAddDisplayDevice(error));
  }
}

// PUT update
const UpdateDisplayDeviceApi = (action: PayloadAction<any>) =>
  api.put(`/display-devices/${action.payload.id}`, action.payload);

export function* UpdateDisplayDeviceCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(UpdateDisplayDeviceApi, action);
    yield put(successUpdateDisplayDevice(response.data));
  } catch (error) {
    yield put(failureUpdateDisplayDevice(error));
  }
}

// DELETE
const DeleteDisplayDeviceApi = (action: PayloadAction<string>) =>
  api.delete(`/display-devices/${action.payload}`);

export function* DeleteDisplayDeviceCall(action: PayloadAction<string>) {
  try {
    const response: AxiosResponse = yield call(DeleteDisplayDeviceApi, action);
    yield put(successDeleteDisplayDevice(response.data));
  } catch (error) {
    yield put(failureDeleteDisplayDevice(error));
  }
}
